var _circle, _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13705_101826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F1F1FF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13705_101826)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13705_101826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13705_101826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#F1F1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13705_101826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13705_101826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 63.5133C61.9418 63.5133 71.6222 53.8329 71.6222 41.8916C71.6222 29.9503 61.9418 20.27 50.0005 20.27C38.0592 20.27 28.3789 29.9503 28.3789 41.8916C28.3789 53.8329 38.0592 63.5133 50.0005 63.5133Z",
    fill: "#9DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6641 25.1377C66.7062 28.8629 68.532 33.6212 68.532 38.8059C68.532 50.7473 58.8518 60.4275 46.9104 60.4275C41.7257 60.4275 36.9674 58.6017 33.2422 55.5596C37.2077 60.414 43.2392 63.5131 49.9959 63.5131C61.9374 63.5131 71.6176 53.8329 71.6176 41.8914C71.6176 35.1347 68.5185 29.1032 63.6641 25.1377Z",
    fill: "#8792F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9087 60.3506C68.8351 60.4257 68.7616 60.5022 68.6865 60.5773C66.2616 63.0022 63.4357 64.9076 60.2886 66.2395C57.0273 67.6179 53.5664 68.3176 50.0003 68.3176C46.4342 68.3176 42.9733 67.6179 39.712 66.2395C36.5649 64.9076 33.739 63.0037 31.3141 60.5773C31.239 60.5022 31.1655 60.4257 31.0919 60.3506C21.9928 63.9557 14.1715 70.0878 8.48828 77.8776C17.4673 91.22 32.7075 99.9992 50.0003 99.9992C67.2931 99.9992 82.5333 91.22 91.5123 77.8776C85.8291 70.0863 78.0078 63.9557 68.9087 60.3506Z",
    fill: "#9DA7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13705_101826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13705_101826)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M84.1835 86.488H84.1805C84.1805 86.488 65.8456 87.9175 56.7616 86.488L56.757 86.4865L60.6444 93.8319C42.2676 93.7928 26.5498 82.4445 20.0724 66.3784C15.6279 69.5721 11.7135 73.458 8.48828 77.8799C17.4673 91.2208 32.7075 100 50.0003 100C63.221 100 75.2435 94.8679 84.1835 86.488Z",
    fill: "#F1F1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.37fb58a2406ae5adfaa547c27b065b56.svg";
export { ForwardRef as ReactComponent };